import React from 'react';

function ServicioAdmin() {
  return <div>Registrar Negocio</div>;
}

export default ServicioAdmin;
